import React from 'react';
import {getLeague} from "@/shared/utils/users";
import {useStore} from "@/app/providers/StoreProvider";
import ImgGoldLeague from '@/shared/pictures/gold_league.png';
import ImgSilverLeague from '@/shared/pictures/silver_league.png';
import ImgBronzeLeague from '@/shared/pictures/bronze_league.png';
import ImgInfo from '@/shared/pictures/Info.svg';
import {leagueType} from "@/entities/user/types";
import {observer} from "mobx-react-lite";


export const RatingLeague = observer(() => {
    const {userStore} = useStore();
    const {gameInfo, league} = userStore;

    const getImgLeague = () => {
        const type = getLeague(gameInfo, league).type;
        switch (type) {
            case leagueType.Bronze:
                return <img className='rating-league_img' src={ImgBronzeLeague} alt=""/>
            case leagueType.Silver:
                return <img className='rating-league_img' src={ImgSilverLeague} alt=""/>
            case leagueType.Gold:
                return <img className='rating-league_img' src={ImgGoldLeague} alt=""/>
            default:
                const exhaustiveCheck: never = type;
                return exhaustiveCheck;
        }
    }
    return (
        <div className='rating-league'>
            <h2 className='rating-league_name'>{getLeague(gameInfo, league).text}</h2>
            {getImgLeague()}
            <img className='rating-league_info' src={ImgInfo} alt="info"/>
        </div>
    );
});
